/**
 * Google Calendar scopes required for creating events
 */
export const GOOGLE_CALENDAR_SCOPES = [
  "https://www.googleapis.com/auth/calendar.calendars",
  "https://www.googleapis.com/auth/calendar.events",
];

/**
 * Zoom scopes required for meeting management
 */
export const ZOOM_MEETING_SCOPES = [
  "user:read:user",
  // TODO Can we go more granular?
  // https://developers.zoom.us/docs/api/rest/reference/zoom-api/methods/#operation/meetingCreate
  "meeting:write:meeting",
];
